// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"341":"31d6cfe0","799":"a9a00cc5","936":"91591461"}[chunkId] + ".chunk.css";
};